const MOBILE_ORDER_SEARCH_SITE_IDS: number[] = [2];

export default MOBILE_ORDER_SEARCH_SITE_IDS;
